import type { BuildTrayRoster, TrayRosterEntry } from "./types";

/**
 * By product, biggest first — different trays are different prices, and
 * "how much Bodenkanal is drawn" is the question he is actually checking.
 *
 * The metres come from the SAME geometry the plan draws, so the number in the
 * panel and the line on the sheet can never disagree. A tray type read off the
 * run's own coverage table could.
 */
export const buildTrayRoster: BuildTrayRoster = ({ trays, pointsPerMetre }) => {
  const byType = new Map<string, TrayRosterEntry>();
  trays.forEach((tray) => {
    const held = byType.get(tray.type) ?? {
      type: tray.type,
      segmentCount: 0,
      metres: 0,
    };
    const dx = tray.to.x - tray.from.x;
    const dy = tray.to.y - tray.from.y;
    held.segmentCount += 1;
    held.metres +=
      pointsPerMetre > 0 ? Math.sqrt(dx * dx + dy * dy) / pointsPerMetre : 0;
    byType.set(tray.type, held);
  });

  // Biggest first, and the name breaks every tie so the rows cannot reshuffle
  // between renders.
  return [...byType.values()].sort(
    (a, b) => b.metres - a.metres || a.type.localeCompare(b.type),
  );
};
